<template>
  <footer class="github-footer">
    <div class="footer-inner">
      <span class="footer-copy">© 2026 陈程 · 简历持续更新</span>
      <span class="footer-sep"></span>
      <a class="footer-link" href="https://github.com/GuoyiZhang/078-Vue-resumeVue" target="_blank" rel="noopener">
        源码托管在 GitHub，欢迎 star
      </a>
      <button class="to-top" type="button" title="回到顶部" aria-label="回到顶部" @click="toTop">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m6 15 6-6 6 6"></path>
        </svg>
      </button>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Foot',
  methods: {
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
